import { render, staticRenderFns } from "./sub-step-card.vue?vue&type=template&id=a91ae7f2&scoped=true&"
import script from "./sub-step-card.vue?vue&type=script&lang=js&"
export * from "./sub-step-card.vue?vue&type=script&lang=js&"
import style0 from "./sub-step-card.vue?vue&type=style&index=0&id=a91ae7f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91ae7f2",
  null
  
)

export default component.exports